import { FrameProduct, Product, ProductType } from '../';

export function IsFrameProduct(product: Product): product is FrameProduct {
  return (product as FrameProduct).productType === ProductType.FRAME;
}
